import {ILocation, ILocationAPI, ILocationQuery} from 'interfaces';
import {axiosAPI} from './API';

interface ILocationCreateResponse {
    id: number,
}

// device crud operations, conversions, and caching
class _LocationService {

    public getLocations = (query: ILocationQuery): Promise<ILocation[]> => {

        const p = axiosAPI.get<ILocationAPI[]>('/locations', {params: query})
            .then((resp) => {
                var locs = resp.data.map(this.mapLocationFromServer);
                return locs;
            });
            
        p.catch((err) => {
            console.error('Error getting locations: ', err);
        });

        return p;
    }

    public createLocation = (loc: ILocation): Promise<ILocationCreateResponse> => {

        const p = axiosAPI.post<ILocationCreateResponse>('/locations', this.mapLocationToServer(loc))
            .then((resp) => {
                return resp.data;
            });
            
        p.catch((err) => {
            console.error('Error creating location: ', err);
        });

        return p;
    }

    public updateLocation = (id: number, loc: ILocation): Promise<ILocationCreateResponse> => {

        const p = axiosAPI.patch<ILocationCreateResponse>(`/locations/${id}`, this.mapLocationToServer(loc))
            .then((resp) => {
                return resp.data;
            });
            
        p.catch((err) => {
            console.error('Error updating location: ', err);
        });

        return p;
    }

    public deleteLocation = (id: number): Promise<any> => {

        const p = axiosAPI.delete(`/locations/${id}`)
            .then((resp) => {
                return resp.data;
            });
            
        p.catch((err) => {
            console.error('Error deleting location: ', err);
        });

        return p;
    }

    public mapLocationFromServer = (l: ILocationAPI): ILocation => {
        return {
            ...l,
            createdAt: l.createdAt ? new Date(l.createdAt) : undefined,
            updatedAt: l.updatedAt ? new Date(l.updatedAt) : undefined,
        }
    }

    public mapLocationToServer = (l: ILocation): ILocationAPI => {
        return {
            ...l,
            id: l.id ? l.id : 0,
            createdAt: l.createdAt ? l.createdAt.toISOString() : "",
            updatedAt: l.updatedAt ? l.updatedAt.toISOString() : "",
        }
    }
}

export const LocationService = new _LocationService();
